import {Col, Row} from 'react-bootstrap';
import {FastRobotErrorcode, SignalREvent, SignalRHub} from '../../constants/dataEnum';
import {hideLoading, showLoading} from '../actions/appStateAction';
import {hideModal, showModal} from '../actions/modalStateAction';
import {invokeAPI, resolveIntl, setErrorCodeNumber} from './commonBusiness';
import {checkProtocolExecutorAndShowBusyModal, showDefaultErrorModal} from './commonModalBusiness';
// eslint-disable-next-line import/no-cycle
import {showEmergencyStopModal} from './emergencyStopBusiness';
import {shouldUseLicense} from './licenseBusiness';
import {
  noLicenseActivatedModal,
  showModalMotorCollisionSkipped,
  showModalTouchProbeExtendedEnterAutomatically,
} from './modalStateBusinessAction';
// eslint-disable-next-line import/no-cycle
import {handleIncompatibleVisionVersionError} from './plateRecognitionBusiness';

const intl = resolveIntl();

export const recoveryResponseHandler =
  (action, abortCallback = () => {}) =>
  (dispatch) => {
    const modalText = (
      <div>
        <Row>
          <Col xs={12} md={12}>
            {intl.formatMessage({id: 'runtime.recoveryManualModal.text'})}
          </Col>
        </Row>
      </div>
    );
    dispatch(
      showModal(
        intl.formatMessage({id: 'runtime.recoveryManualModal.title'}),
        modalText,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
              dispatch(showLoading(intl.formatMessage({id: 'recoveryAction.loading'})));
              try {
                action();
              } catch (error) {
                console.log('Recovery Failed');
              }
            },
            text: intl.formatMessage({id: 'runtime.recoveryManualModal.firstButton'}),
          },
          {
            className: 'btn-lg',
            style: 'secondary',
            handlerClick: () => {
              dispatch(hideModal());
              abortCallback();
            },
            text: intl.formatMessage({id: 'runtime.recoveryManualModal.secondButton'}),
          },
        ],
        () => dispatch(hideModal()),
        'recoveryModal',
        true,
      ),
    );
  };

export function fastRecovery(callback, alternateCallback, responseCallback) {
  return async (dispatch) => {
    dispatch(
      showLoading(
        intl.formatMessage({
          id: 'fastSignalRHelper.fastRecovery.loading',
        }),
      ),
    );

    const useLicense = await dispatch(shouldUseLicense());

    await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_FAST_RECOVERY, false, useLicense)).then(
      async (response) => {
        console.log(SignalREvent.SAFE_FAST_RECOVERY, 'response', response);
        dispatch(hideLoading());
        if (responseCallback) {
          responseCallback(response);
        }

        if (response !== FastRobotErrorcode.NoError) {
          await dispatch(setErrorCodeNumber(response));
        }

        switch (response) {
          case FastRobotErrorcode.NoError: {
            if (callback) {
              callback();
              // eslint-disable-next-line no-param-reassign
              callback = null;
            }
            break;
          }
          case FastRobotErrorcode.ActuatorUnexpectedTrigger:
          case FastRobotErrorcode.ActuatorAborted:
          case FastRobotErrorcode.ActuatorNotReady:
          case FastRobotErrorcode.ActuatorFollowingErrorIdle: // motor skipped
          case FastRobotErrorcode.ActuatorFollowingErrorMoving: // motor skipped
          case FastRobotErrorcode.ActuatorEncoderError: {
            dispatch(
              showModalMotorCollisionSkipped(async () => {
                dispatch(showLoading(intl.formatMessage({id: 'recoveryAction.loading'})));
                await dispatch(fastRecovery());
                dispatch(hideLoading());
                dispatch(
                  recoveryResponseHandler(() => dispatch(fastRecovery(callback, alternateCallback)), alternateCallback),
                );
              }),
            );
            break;
          }
          case FastRobotErrorcode.Busy: {
            dispatch(checkProtocolExecutorAndShowBusyModal());
            break;
          }
          case FastRobotErrorcode.TouchProbeExpanded: {
            dispatch(showModalTouchProbeExtendedEnterAutomatically());
            break;
          }
          case FastRobotErrorcode.ActuatorEmergencyStop: {
            dispatch(showEmergencyStopModal(fastRecovery));
            break;
          }
          case FastRobotErrorcode.NO_LICENSE_ACTIVATED: {
            dispatch(noLicenseActivatedModal());
            break;
          }
          case FastRobotErrorcode.INCOMPATIBLE_VISION_VERSION: {
            dispatch(handleIncompatibleVisionVersionError());
            break;
          }
          default: {
            dispatch(showDefaultErrorModal(response));
          }
        }
      },
    );
  };
}
